import { Button, Card, Heading, Link, Tag } from '@digdir/designsystemet-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Energimerke } from '../../../../../components/energimerke/energimerke';
import useFormatDate from '../../../../../hooks/useFormatDate';
import { fromEnergiplanToEnergimerke } from '../../../../../components/energimerke/utils';
import { SimpleEnergyAnalysis } from '../../../../../types/building';

import { ShareButton } from './shareButton';
import { AttestHeaderWrapper, ButtonWrapper } from './styledComponents';

interface Props {
  energyAnalysis?: SimpleEnergyAnalysis;
}

export const AttestCard: FC<Props> = ({ energyAnalysis }) => {
  const { t } = useTranslation();
  const { addYearsToDate } = useFormatDate();
  const energimerke = fromEnergiplanToEnergimerke(energyAnalysis?.energiplan);
  const attestUrl = energyAnalysis?.energiplan?.attestUri;

  const publisertDato = energyAnalysis?.energiplan?.publisertDato;

  if (!publisertDato || !attestUrl) {
    return null;
  }

  // Energiattest is valid for 10 years from published date
  const gyldigTilDato = addYearsToDate(publisertDato, 10);

  return (
    <Card>
      <AttestHeaderWrapper>
        <Heading level={2} data-size="xs">
          {t('energiattestPage.info.title')}
        </Heading>
        <Tag data-color="success">{t('energiattestPage.info.validTo', { date: gyldigTilDato })}</Tag>
      </AttestHeaderWrapper>
      <Energimerke energimerke={energimerke} />

      <ButtonWrapper>
        <Button asChild variant="secondary">
          <Link target="_blank" rel="noreferrer" href={attestUrl} download>
            {t('energiattestPage.buttons.download')}
          </Link>
        </Button>
        <ShareButton attestUrl={attestUrl} />
      </ButtonWrapper>
    </Card>
  );
};
